module.exports = __webpack_public_path__ + "img/7_74.3616c648.png";